module.exports = __webpack_public_path__ + "img/logo.cb86fd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.png
// module id = KItN
// module chunks = 0